import { useState } from 'react';

const faqItems = [
  {
    q: '女神漫画网有哪些类型的漫画可以追更？',
    a: '女神漫画网追更频道覆盖韩漫、日漫、国漫三大品类，题材涵盖都市言情、奇幻冒险、悬疑推理、科幻巨制、热血战斗、浪漫喜剧等十余种类型。无论你喜欢哪种风格，都能在这里找到适合自己的连载作品，免费全集持续更新中。',
  },
  {
    q: '如何使用追更提醒功能？',
    a: '在女神漫画网找到你正在追的漫画后，点击订阅按钮即可开通更新提醒。每当该漫画有最新话发布，系统会第一时间通过推送通知你，确保你不会错过任何一话的精彩内容。下拉式追更体验让阅读更流畅。',
  },
  {
    q: '女神漫画网是否完全免费？',
    a: '是的，女神漫画网提供海量漫画免费全集在线阅读服务。我们持续收录各大平台的免费资源，韩漫、日漫、国漫均可免费追更，无需付费即可畅享完整的连载阅读体验。部分独家内容也面向注册用户免费开放。',
  },
  {
    q: '移动端访问体验如何？',
    a: '女神漫画网已全面适配移动端浏览器，在手机和平板上均可获得流畅的追更体验。我们特别优化了下拉式阅读模式，让你在移动设备上也能像刷社交媒体一样轻松追漫，无需安装任何 App。',
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            关于女神漫画网追更服务的常见疑问解答
          </p>
        </div>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left transition-colors hover:bg-background-100 cursor-pointer"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <div className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-all duration-300 ${
                  openIdx === idx ? 'bg-primary-100 rotate-180' : 'bg-background-200'
                }`}>
                  <i className={`text-sm transition-colors ${
                    openIdx === idx ? 'ri-subtract-line text-primary-600' : 'ri-add-line text-foreground-600'
                  }`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}